import { Typography } from '@automata/ui';
import Box from '@mui/material/Box';

import { GroupForm } from 'components/GroupForm';
import { ResourceActions } from 'components/ResourceActions';
import { WorkflowForm } from 'components/WorkflowForm';
import { ModelNames } from 'model/types';
import { RoutedGroup } from 'screens/DevicesScreen/DevicesList/types';

import { CommonProps } from './types';

export const Form = ({
  resource,
  resourceID,
  resourceType,
  resourceAction,
  onClose,
  requestAuthorisation,
}: CommonProps) => {
  const forms = {
    [ModelNames.WORKFLOW]: (
      <WorkflowForm
        workflowID={resourceID}
        mode={resourceAction}
        onClose={onClose}
        requestAuthorisation={requestAuthorisation}
      />
    ),
    [ModelNames.GROUP]: (
      <GroupForm
        group={resource as RoutedGroup}
        mode={resourceAction}
        onClose={onClose}
      />
    ),
  };

  return (
    <>
      {resourceAction !== ResourceActions.CREATE &&
        resourceAction !== ResourceActions.EXPORT && (
          <Typography variant="body1">
            {`Are you sure you want to ${resourceAction.toLowerCase()} this ${resourceType}?`}
          </Typography>
        )}
      <Box marginTop={1}>{forms[resourceType]}</Box>
    </>
  );
};
